import { Box, BoxProps, PremiumSummary, smBumps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCoverLevelOption, Quote } from '../../../../domain'
import { useQuotePremiums } from '../../../../hooks/premiums'
import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { ProductConfig } from '../../../../state/configuration'
import { toDateTime } from '../../../../util/date'

export interface AnnualSummaryPremiumsProps extends BoxProps {
  currentQuote: Quote
  product: ProductConfig
}

const tKey = TKey('components.annual-summary-premium')

export const AnnualSummaryPremium: FunctionComponent<AnnualSummaryPremiumsProps> = ({
  currentQuote,
  product,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const currentPremiums = useQuotePremiums(currentQuote, product)

  const promotion = getCoverLevelOption(currentQuote)?.promotion

  const termTotalFormatted = t(tFormats('currency.long'), {
    amount: currentPremiums.totals.term,
  })

  const termTotal = t(tKey('term-total-amount'), {
    amount: termTotalFormatted,
  })

  const promo = promotion?.endAt
    ? t(tKey('promotion', 'until'), {
        date: t(tFormats('date.long'), {
          value: toDateTime(promotion.endAt),
        }),
      })
    : undefined

  const header = t(tKey(currentPremiums?.paymentSchedule, 'header'))

  const subheader = [
    ...(currentPremiums?.paymentSchedule === 'MONTHLY' ? [termTotal] : []),
    promo,
  ]
    .filter(Boolean)
    .join('\n')

  const currentAmount = t(tFormats('currency.long'), {
    amount: currentPremiums.totals.discounted,
  })

  return (
    <Box p={2} {...props}>
      <PremiumSummary
        p={smBumps}
        header={header}
        subheader={subheader}
        currentAmount={currentAmount}
      />
    </Box>
  )
}
